//
// WARNING: this file was auto-generated by @phensley/cldr-compiler. DO NOT EDIT.
//
export var dayPeriodKeys = [
    'afternoon1', 'evening1', 'midnight', 'morning1', 'morning2', 'night1', 'noon'
];
export var dayPeriodRules = {
    af: '2 5 3 0 1|0 1 8c k0 u0',
    am: '2 5 3 6 0 1|0 1 a0 k0 k1 u0',
    ar: '5 3 4 0 1|0 50 a0 k0 u0',
    az: '2 3 4 6 0 1 5|0 6o a0 k0 k1 sc vo',
    bg: '2 5 3 4 0 1 5|0 1 6o ic nc u0 10o',
    blo: '5 3 4 0 1|0 6o bo k0 xc',
    bn: '5 3 4 0 1 5|0 6o a0 k0 u0 xc',
    bs: '2 5 3 6 0 1 5|0 1 6o k0 k1 u0 z0',
    ca: '2 3 4 0 1 5|0 1 a0 k0 vo z0',
    ccp: '5 3 4 0 1 5|0 6o a0 k0 u0 xc',
    chr: '3 6 0|0 k0 k1',
    cs: '2 5 3 4 6 0 1 5|0 1 6o f0 k0 k1 u0 10o',
    cy: '2 3 6 0 1|0 1 k0 k1 u0',
    da: '2 5 3 4 0 1|0 1 8c go k0 u0',
    de: '2 5 3 4 0 1|0 1 8c go k0 u0',
    ee: '5 3 4 0 1 5|0 6o 8c k0 u0 z0',
    el: '5 3 0 1 5|0 6o k0 sc xc',
    en: '2 3 6 0 1 5|0 1 k0 k1 u0 z0',
    es: '3 4 6 1 5|0 a0 k0 k1 xc',
    'es-CO': '4 6 1 5|0 k0 k1 xc',
    et: '2 5 3 6 0 1 5|0 1 8c k0 k1 u0 12c',
    eu: '2 3 4 0 1 5|0 1 a0 k0 vo z0',
    fa: '3 4 0 5|1o 6o k0 vo',
    fi: '2 5 3 4 6 0 1 5|0 1 8c go k0 k1 u0 12c',
    fil: '2 3 4 6 0 1 5|0 1 a0 k0 k1 qo u0',
    fr: '2 5 3 6 0 1|0 1 6o k0 k1 u0',
    gl: '2 3 4 0 1 5|0 1 a0 k0 lo z0',
    gsw: '2 5 3 0 1|0 1 8c k0 u0',
    gu: '2 5 3 0 1 5|0 1 6o k0 qo xc',
    he: '2 5 3 0 1 5|0 1 a0 k0 u0 10o',
    hi: '2 5 3 0 1 5|0 1 6o k0 qo xc',
    'hi-Latn': '2 5 3 6 0 1 5|0 1 6o k0 k1 qo xc',
    hr: '2 5 3 6 0 1 5|0 1 6o k0 k1 u0 z0',
    hu: '2 5 3 4 6 0 1 5|0 1 a0 f0 k0 k1 u0 z0',
    hy: '2 5 3 6 0 1|0 1 a0 k0 k1 u0',
    id: '2 3 0 6 1 5|0 1 go k0 p0 u0',
    is: '2 5 3 6 0 1|0 1 a0 k0 k1 u0',
    it: '2 5 3 6 0 1|0 1 a0 k0 k1 u0',
    ja: '2 3 6 0 1 5|0 6o k0 k1 qo vo',
    ka: '2 5 3 6 0 1 5|0 1 8c k0 k1 u0 z0',
    kgp: '2 5 3 6 0 1|0 1 a0 k0 k1 vo',
    kk: '2 5 3 6 0 1 5|0 1 a0 k0 k1 u0 z0',
    km: '2 3 6 0 1 5|0 1 k0 k1 u0 z0',
    kn: '2 5 3 0 1 5|0 1 a0 k0 u0 z0',
    ko: '2 5 3 4 6 0 1 5|0 1 50 a0 k0 k1 u0 z0',
    kok: '2 5 3 0 1 5|0 1 6o k0 qo xc',
    'kok-Latn': '2 5 3 0 1 5|0 1 6o k0 qo xc',
    ky: '2 5 3 6 0 1 5|0 1 a0 k0 k1 u0 z0',
    lij: '2 5 3 6 0 1 5|0 1 a0 k0 k1 u0 10o',
    lo: '2 5 3 6 0 1 5|0 1 8c k0 k1 qo xc',
    lt: '2 5 3 6 0 1|0 1 a0 k0 k1 u0',
    lv: '2 5 3 6 0 1 5|0 1 a0 k0 k1 u0 12c',
    mk: '2 5 3 4 6 0 1|0 1 6o go k0 k1 u0',
    ml: '2 5 3 4 6 0 1 5|0 1 50 a0 k0 k1 p0 vo',
    mn: '2 5 3 6 0 1 5|0 1 a0 k0 k1 u0 z0',
    mr: '2 5 3 4 6 0 1 5|0 1 6o a0 k0 k1 qo z0',
    ms: '3 4 0 1 5|0 1o k0 nc vo',
    my: '2 3 6 0 1 5|0 1 k0 k1 qo vo',
    nb: '2 5 3 4 0 1|0 1 a0 go k0 u0',
    ne: '2 5 3 6 0 1 5|0 1 6o k0 k1 vo 10o',
    nl: '2 5 3 0 1|0 1 a0 k0 u0',
    nn: '2 5 3 4 0 1|0 1 a0 go k0 u0',
    no: '2 5 3 4 0 1|0 1 a0 go k0 u0',
    pa: '2 5 3 0 1 5|0 1 6o k0 qo z0',
    pl: '2 5 3 4 6 0 1 5|0 1 a0 go k0 k1 u0 z0',
    pt: '2 5 3 6 0 1|0 1 a0 k0 k1 vo',
    ro: '2 5 3 6 0 1 5|0 1 8c k0 k1 u0 10o',
    ru: '2 5 3 6 0 1 5|0 1 6o k0 k1 u0 10o',
    scn: '2 5 3 6 0 1|0 1 6o k0 k1 u0',
    si: '2 3 4 6 0 1 5|0 1o a0 k0 k1 nc u0',
    sk: '2 5 3 4 6 0 1 5|0 1 6o f0 k0 k1 u0 10o',
    sl: '2 5 3 4 6 0 1 5|0 1 a0 go k0 k1 u0 10o',
    sq: '2 5 3 4 6 0 1|0 1 6o f0 k0 k1 u0',
    sr: '2 5 3 6 0 1 5|0 1 a0 k0 k1 u0 z0',
    sv: '2 5 3 4 0 1|0 1 8c go k0 u0',
    sw: '2 5 3 4 6 0 1 5|0 1 6o bo k0 k1 qo vo',
    ta: '2 5 3 4 6 0 1 5|0 1 50 8c k0 k1 qo z0',
    te: '2 5 3 0 1 5|0 1 a0 k0 u0 z0',
    th: '2 5 3 6 0 1 5|0 1 a0 k0 k1 qo z0',
    tr: '2 5 3 4 6 0 1 5|0 1 a0 ic k0 k1 vo z0',
    uk: '2 5 3 6 0 1|0 1 6o k0 k1 u0',
    ur: '2 5 3 0 1 5|0 1 6o k0 u0 xc',
    uz: '2 5 3 0 6 1 5|0 1 a0 ic k0 u0 10o',
    vi: '2 5 3 6 0 1 5|0 1 6o k0 k1 u0 z0',
    yrl: '2 5 3 6 0 1|0 1 a0 k0 k1 vo',
    yue: '2 5 3 4 0 1|0 1 8c dc k0 vo',
    zh: '2 5 3 4 0 1|0 1 8c dc k0 vo',
    zu: '3 4 0 1 5|0 a0 go lo vo',
};
//# sourceMappingURL=autogen.dayperiods.js.map